import { Directive, ElementRef } from '@angular/core';
import { IonInput, IonTextarea } from '@ionic/angular/standalone';

interface InputElementAccess { getInputElement: () => Promise<HTMLElement> }

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'ion-input[autofocus], ion-textarea[autofocus], ion-searchbar[autofocus]',
  standalone: true
})
export class AutoFocusDirective {
  constructor(private el: ElementRef) {
    const ionEl = this.el.nativeElement as IonInput | IonTextarea;
    if (ionEl.autofocus) {
      (ionEl as InputElementAccess).getInputElement().then((focusElement) => {
        setTimeout(() => focusElement.focus(), 500);
      });
    }
  }
}
